export const CUT_OFF_LARGE_SCREEN_WIDTH = 1170;
export const CUT_OFF_MEDIUM_SCREEN_WIDTH = 768;
export const CUT_OFF_SMALL_SCREEN_WIDTH = 576;
